import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-getting-start-section',
    templateUrl: './getting-start-section.component.html',
    styleUrls: ['./getting-start-section.component.scss'],
    standalone: false
})
export class GettingStartSectionComponent implements OnInit {
@Input() sections1: any = null;
@Input() showTourLink: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
